import { RootState } from 'configs/redux';

export const evaluationOrderSelector = (state: RootState) =>
  state.evaluationOrder;
